module.exports = __webpack_public_path__ + "img/icon_unlock_black.ae9e6a9b.svg";